import { preview } from '@/components/form/preview'
import { Tooltip } from '@/components/primitives/Tooltip'
import { MoreHoriz } from '@mui/icons-material'
import { Box, IconButton, Menu, MenuItem, Stack } from '@mui/material'
import { useCallback, useState } from 'react'
import { useCopyDynamicLoadsCfModal } from '../../../modals/CopyDynamicLoadsCfModal'
import { useTexts } from './useTexts'

interface Props {
  territory: uui.domain.client.rm.Territory
  hasOnlyOneTerritory: boolean
}

export function DynamicLoadsCfView(props: Props) {
  const {
    hasOnlyOneTerritory,
    territory: { enableDynamicCustomFields, enableDynamicLoads },
  } = props
  const texts = useTexts()

  const { show: showModal, Modal: CopyDynamicLoadsCfModal } = useCopyDynamicLoadsCfModal()

  const nothingSelected = !enableDynamicLoads && !enableDynamicCustomFields

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)

  const handleMoreClick = useCallback(
    (event: React.MouseEvent<HTMLElement>) => {
      setAnchorEl(event.currentTarget)
    },
    [nothingSelected],
  )

  const handleMenuClose = useCallback(() => {
    setAnchorEl(null)
  }, [])

  const handleCopySettingsClick = useCallback(() => {
    handleMenuClose()
    showModal()
  }, [handleMenuClose, showModal])

  return (
    <>
      <Stack direction="column" data-testid="driver-activity-dynamic-loads-cf">
        <Stack direction="row" alignItems="center">
          <preview.Label>{texts.title}</preview.Label>
          <Box marginLeft="auto" display="flex" alignItems="flex-start">
            <Tooltip title={texts.more} placement="top">
              <IconButton
                onClick={handleMoreClick}
                disabled={hasOnlyOneTerritory}
                data-testid="driver-activity-dynamic-loads-cf_copy-btn"
                data-trackid="driver-activity-dynamic-loads-cf_copy-btn"
              >
                <MoreHoriz />
              </IconButton>
            </Tooltip>
          </Box>
        </Stack>
        <preview.Field label={null}>
          <preview.Value variant="alternative">{enableDynamicLoads && texts.loads}</preview.Value>
          <preview.Value variant="alternative">
            {enableDynamicCustomFields && texts.customFields}
          </preview.Value>
          {nothingSelected && (
            <preview.Value variant="alternative">
              <preview.NullValue />
            </preview.Value>
          )}
        </preview.Field>
      </Stack>
      <Menu anchorEl={anchorEl} open={open} onClose={handleMenuClose}>
        <MenuItem onClick={handleCopySettingsClick}>{texts.copySettingsToTerritory}</MenuItem>
      </Menu>
      <CopyDynamicLoadsCfModal />
    </>
  )
}
